export default __webpack_public_path__ + "static/media/khaf-smart-sec3.223c9aa9.jpg";